import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import { getMonitors } from 'redux/reducers';

import './MonitorSelection.css';
import { CHANGE_ACCESSORY_CHOICES, CHANGE_FILTER_CHOICES } from 'redux/actions';

const changeAccessoryChoices = newAccessoryChoices => ({ type: CHANGE_ACCESSORY_CHOICES, newAccessoryChoices });
const changeFilterChoices = newFilterChoices => ({ type: CHANGE_FILTER_CHOICES, newFilterChoices });

const singleFamilyId = (id, idx = 0) => Array.isArray(id) ? id[idx] : id;

const SelectedFamily = ({ selectedFamily, getString }) => {
  console.log({selectedFamily});
  return (
    <div className="centered family">
      <div className="monitor-family-blue-btn-pointer" />
      { selectedFamily.monitors.map(id => (
        <div key={singleFamilyId(id)} className="monitor-block-container">
          <div className="monitor-block">
            <Link to={`/config/${singleFamilyId(id, 1)}`} className="monitor-image-block">
              <img
                src={`${process.env.PUBLIC_URL}/images/select-${singleFamilyId(id)}.jpg`}
                className="img-responsive"
                alt={getString(singleFamilyId(id), 'monitor')}
              />
            </Link>
          </div>
          {
            Array.isArray(id)
              ? id.slice(1).map($id => (
                <Link key={$id} to={`/config/${$id}`} className="blue-btn monitor-blue-btn monitor-unit-blue-btn">
                  {getString($id, 'monitor')}
                </Link>
              )) : (
                <Link to={`/config/${id}`} className="blue-btn monitor-blue-btn monitor-unit-blue-btn">
                  {getString(id, 'monitor')}
                </Link>
              )
          }
        </div>
      ))}
    </div>
  )
};

SelectedFamily.propTypes = {
  getString: PropTypes.func.isRequired,
  selectedFamily: PropTypes.shape().isRequired,
};

const MonitorFamily = ({ family, getString, selectedFamily }) => {

  const makeFamilyLink = family => family.monitors.length > 1
    ? `/monitor/${family.id}`
    : `/config/${family.monitors[0]}`;

  return (
    <div key={family.id} className="monitor-block-container">
      <div className="monitor-block">
        <Link to={makeFamilyLink(family)} className="monitor-image-block">
          <img
            src={`${process.env.PUBLIC_URL}/images/family-${family.id}.jpg`}
            className="img-responsive"
            alt={getString(family.id, 'monitor')}
          />
        </Link>
      </div>
      <Link to={makeFamilyLink(family)} className="blue-btn monitor-blue-btn">
        {getString(family.id, 'monitor')}
      </Link>
      {
        family === selectedFamily && <div className="monitor-blue-btn-pointer" />
      }
    </div>
  );
};

const MonitorSelection = ({ familyId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // always clear choices in configurator when choosing new monitor
    dispatch(changeAccessoryChoices(null));
    dispatch(changeFilterChoices(null));
  }, []);

  const getString = useSelector(state => state.strings.getString);
  const monitors = useSelector(state => getMonitors(state));
  const selectedFamilyIdx = monitors.families.findIndex(family => family.id === familyId);
  const selectedFamily = selectedFamilyIdx >= 0
    ? monitors.families[selectedFamilyIdx]
    : null;

  const beforeFamily = monitors.families.slice(0, selectedFamilyIdx + 1);
  const afterFamily = monitors.families.slice(selectedFamilyIdx + 1);

  return (
    <div className="monitor-selection header-border">
      <div className="text-center">
        <h2 className="block-head">
          <span className="number">
            1
          </span>
          <span>
            {getString('monitor', 'general')}
          </span>
        </h2>
      </div>
      <MediaQuery key="mobile" query="(max-width: 991.98px)">
        <div className="centered">
        {
          beforeFamily.map(family => (
            <MonitorFamily
              key={family.id}
              family={family}
              getString={getString}
              selectedFamily={selectedFamily}
            />
          ))
        }
        </div>
        {
          familyId !== '' && <SelectedFamily getString={getString} selectedFamily={selectedFamily} />
        }
        <div className="centered">
          { afterFamily.map(family => (
            <MonitorFamily
              key={family.id}
              family={family}
              getString={getString}
              selectedFamily={selectedFamily}
            />
          ))
          }
        </div>
      </MediaQuery>
      <MediaQuery key="lg" query="(min-width: 992px)">
        <div className="centered">
          { monitors.families.map(family => (
            <MonitorFamily
              key={family.id}
              family={family}
              getString={getString}
              selectedFamily={selectedFamily}
            />
          ))
          }
        </div>
        {
          selectedFamily && <SelectedFamily getString={getString} selectedFamily={selectedFamily} />
        }
      </MediaQuery>
    </div>
  );
};

MonitorSelection.defaultProps = {
  familyId: '',
};
MonitorSelection.propTypes = {
  familyId: PropTypes.string,
};

export default MonitorSelection;
